import Axios from 'axios'

const axios = Axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    'Access-Control-Allow-Origin': `${process.env.VUE_APP_API_URL}/api`,
    'access-control-allow-headers': 'Authorization',
  },
})

const getAllVehicleModels = async () => {
  return axios.request({
    method: 'GET',
    url: '/api/vehicle-models',
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

const updateVehicleModel = async ({ id, ...data }) => {
  return axios.request({
    method: 'patch',
    url: `/api/vehicle-models/${id}`,
    data: { id: id, ...data },
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

const saveVehicleModel = async (data: Record<string, string>) => {
  return axios.request({
    method: 'POST',
    url: '/api/vehicle-models',
    data,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

const deleteVehicleModel = async id => {
  return axios.request({
    method: 'DELETE',
    url: `/api/vehicle-models/${id}`,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

export default {
  getAllVehicleModels,
  saveVehicleModel,
  updateVehicleModel,
  deleteVehicleModel,
}
